// @flow

import React from 'react';
import { colors } from 'seedling/constants';

export type PreviewIconProps = {
  size: number,
  color: string,
  className?: string,
};

const PreviewIcon = (props: PreviewIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size}
    height={props.size}
    viewBox="0 0 12 12"
    className={props.className}
  >
    <defs>
      <path
        id="preview-a"
        d="M9.57700973,1.42078479 L6.64516129,1.42078479 C6.25321727,1.42078479 5.93548387,1.10273128 5.93548387,0.710392395 C5.93548387,0.318053509 6.25321727,0 6.64516129,0 L11.2903226,0 C11.6822666,0 12,0.318053509 12,0.710392395 L12,5.36023353 C12,5.75257241 11.6822666,6.07062592 11.2903226,6.07062592 C10.8983786,6.07062592 10.5806452,5.75257241 10.5806452,5.36023353 L10.5806452,2.42543135 L6.50181772,6.50836807 C6.22467144,6.78579356 5.77532856,6.78579356 5.49818228,6.50836807 C5.22103601,6.23094259 5.22103601,5.781147 5.49818228,5.50372151 L9.57700973,1.42078479 Z M1.41935484,10.5792152 L9.29032258,10.5792152 L9.29032258,7.69708868 C9.29032258,7.3047498 9.60805598,6.98669629 10,6.98669629 C10.391944,6.98669629 10.7096774,7.3047498 10.7096774,7.69708868 L10.7096774,11.2896076 C10.7096774,11.6819465 10.391944,12 10,12 L0.709677419,12 C0.317733403,12 0,11.6819465 0,11.2896076 L0,1.98992534 C0,1.59758646 0.317733403,1.27953295 0.709677419,1.27953295 L4.32258065,1.27953295 C4.71452466,1.27953295 5.03225806,1.59758646 5.03225806,1.98992534 C5.03225806,2.38226423 4.71452466,2.70031774 4.32258065,2.70031774 L1.41935484,2.70031774 L1.41935484,10.5792152 Z"
      />
    </defs>
    <g fill={props.color} fillRule="evenodd">
      <use fill={props.color} fillRule="nonzero" xlinkHref="#preview-a" />
    </g>
  </svg>
);

PreviewIcon.defaultProps = {
  color: colors.darkestGrey,
  size: 20,
};

export default PreviewIcon;
